import ExternalContext from "common-components/dist/common/components/App/externalContext";

export default ExternalContext;
